import { resetFilters } from "./resetFilters";
import type { SearchFilters } from "../types";

/**
 * Imperatively update uncontrolled form input elements with value
 */
function updateFilters(form: HTMLFormElement, filters: SearchFilters) {
  // Reset all form filters to empty first
  // NOTE: this is only way to update a _removed_ filter from a previous run
  resetFilters(form);

  // Then iterate over all active filters and set the input accordingly
  Object.entries(filters).forEach(([key, valueOrValues]) => {
    if (key === "name") {
      // Search Bar element isn't nested within form element so query on full document
      const searchBarEl = document.querySelector(
        `input[form=${form.id}][name=name]`
      ) as HTMLInputElement;
      if (searchBarEl) {
        searchBarEl.value = valueOrValues as string;
      }
    } else if (typeof valueOrValues === "string") {
      // Field value stored as string so it must be radio buttons for type
      const radioEl = form.querySelector(
        `input[name=${key}][value="${valueOrValues}"]`
      ) as HTMLInputElement;
      if (radioEl) {
        radioEl.checked = true;
      }
    } else if (Array.isArray(valueOrValues)) {
      // Field value stored as array so it must be group of checkboxes
      valueOrValues.forEach((value) => {
        const checkboxEl = form.querySelector(
          `input[name=${key}][value="${value}"]`
        ) as HTMLInputElement;
        if (checkboxEl) {
          checkboxEl.checked = true;
        }
      });
    } else {
      // Field value stored as grouped range inputs, e.g. mintPriceGte and mintPriceLte
      Object.entries(valueOrValues).forEach(([subKey, value]) => {
        const inputEl = form.querySelector(
          `input[name=${key}${subKey[0].toUpperCase()}${subKey.slice(1)}]`
        ) as HTMLInputElement;
        if (inputEl) {
          inputEl.value = value;
        }
      });
    }
  });
}

export { updateFilters };
